import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { ContentStyle, DataGridListStyle, HtmlTooltip } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import NewTicket from "./NewTicket";
import TicketFollowUp from "./TicketFollowUp";
import { useDispatch, useSelector } from "react-redux";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import { loadingTickets } from "../../Redux/Slice/GetTicketsSlice";
import YSSnackBar from "../../uikit/YSSnackBar";
import { v4 as uuid } from "uuid";
import NoRecords from "../../components/NoRecords";
import ErrorOverlay from "../../components/ErrorOverlay";

export default function Ticket() {
  const [id, setId] = useState();
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const columns: GridColDef[] = [
    {
      field: "ticketId",
      headerName: "Ticket ID",
      width: 120,
      cellClassName: "w15",
      headerClassName: "w15",
    },

    {
      field: "issueSummery",
      headerName: "Issue summary",
      width: 350,
      cellClassName: "w40",
      headerClassName: "w40",
      renderCell: ({ row }) => {
        return (
          <>
            <Typography component="div" variant="body2">
              {row?.issueSummery}
            </Typography>
            <HtmlTooltip
              placement="right"
              arrow
              title={<DetailsList row={row} />}
              className="w316"
            >
              <IconButton className="tooltip">
                <img src={InfoIcon} alt="Tooltip" loading="lazy" />
              </IconButton>
            </HtmlTooltip>
          </>
        );
      },
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 120,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "modiefiedDate",
      headerName: "Last Updated",
      width: 120,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "ticketStatus",
      headerName: "Status",
      width: 100,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: (params: any) => {
        return (
          <>
            <YSButton
              size={"medium"}
              color="primary"
              className={"brightgreen"}
              children={params?.row?.ticketStatus}
              onClick={() => {
                handleShowTicketFollowUpPopupClick();
                setId(params?.row?.ticketId);
              }}
              variant={"contained"}
            />
          </>
        );
      },
    },
  ];
  const [newTicketPopup, setNewTicketPopup] = useState(false);
  const handleShowNewTicketPopupClick = () => {
    setNewTicketPopup(true);
  };
  const handleHideNewTicketPopupClick = () => {
    setNewTicketPopup(false);
  };
  const [ticketFollowUpPopup, setTicketFollowUpPopup] = useState(false);
  const handleShowTicketFollowUpPopupClick = () => {
    setTicketFollowUpPopup(true);
  };
  const handleHideTicketFollowUpPopupClick = () => {
    setTicketFollowUpPopup(false);
  };

  const dispatch = useDispatch();
  const TicketsData = useSelector((state: any) => {
    return { ...state?.GetTicketsSlice };
  }); //To get data from redux store state

  const [rowCountState, setRowCountState] = useState(
    TicketsData?.Pagination?.totalItems || 0
  );

  const getTickets = (nextPage: number) => {
    let pageNumber = {
      pageNumber: nextPage,
    };
    dispatch(loadingTickets(pageNumber));
  };
  useEffect(() => {
    getTickets(0);
  }, []);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      TicketsData?.Pagination?.totalItems !== undefined
        ? TicketsData?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [TicketsData?.Pagination?.totalItems, setRowCountState]);
  return (
    <>
      {" "}
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={0}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12} md={6}>
            <Typography component="h6" color="primary" variant="h6">
              Raise a support ticket
            </Typography>
          </Grid>{" "}
          <Grid item xs={12} md={6} style={{ textAlign: "right" }}>
            <YSButton
              onClick={handleShowNewTicketPopupClick}
              className=""
              children={"Raise a Ticket"}
              size={"medium"}
              type="button"
              color="primary"
              variant="contained"
            />{" "}
          </Grid>
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={TicketsData?.Items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columns}
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                paginationMode="server"
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={TicketsData?.error || undefined}
                getRowId={(row) => row.ticketId ?? uuid()}
                loading={TicketsData.isLoading}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                  getTickets(newPage);
                }}
                rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12} textAlign="center" className="btns"></Grid>
        </Grid>{" "}
        <DialogPopup
          windowsize={"md"}
          show={newTicketPopup}
          handleShowPopupClick={handleShowNewTicketPopupClick}
          handleHidePopupClick={handleHideNewTicketPopupClick}
          title="New Ticket"
        >
          <NewTicket
            setMessage={setMessage}
            setOpen={setOpen}
            handleHideNewTicketPopupClick={handleHideNewTicketPopupClick}
            getTickets={getTickets}
          />
        </DialogPopup>
        <DialogPopup
          windowsize={"md"}
          show={ticketFollowUpPopup}
          handleShowPopupClick={handleShowTicketFollowUpPopupClick}
          handleHidePopupClick={handleHideTicketFollowUpPopupClick}
          title="Ticket Follow-Up"
        >
          <TicketFollowUp
            id={id}
            handleHideTicketFollowUpPopupClick={
              handleHideTicketFollowUpPopupClick
            }
          />
        </DialogPopup>
        <YSSnackBar
          open={open}
          message={message}
          variant={"success"}
          handleClose={() => setOpen(false)}
        />
      </ContentStyle>
    </>
  );
}

const DetailsList = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Issue summary:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.issueSummery ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Ticket raised on:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.createdDate ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Last modified on:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.modiefiedDate ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Issue occurred on:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.dateOnIssueOccured ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Issue occurred to:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.issueOccuredTo ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Prescribing as:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.prescribingAs ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State of practice:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.stateOfPratice ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Mail id:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.mailId ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.phoneNumber ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Description:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.detailedDescription ?? "Not Available"}
        </Typography>
      </Grid>
    </Grid>
  );
};
